export const JPG = 'jpg';
export const JPEG = 'jpeg';
export const PNG = 'png';
export const MP3 = 'mp3';
export const AAC = 'aac';
export const MP4 = 'mp4';
export const PDF = 'pdf';
